import { environment } from './../../../../../../environments/environment';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { UsuarioService } from 'src/app/services/shared/usuario.service';
import { ActividadesService } from 'src/app/services/ofertas-laborales/actividades.service';
import { OfertasImageViewerComponent } from '../../../common/ofertas-image-viewer/ofertas-image-viewer.component';

const URL_BACKEND = environment.urlBackend;

interface ImagenGaleria {
    url: string;
    safeUrl: SafeUrl;
    nombre: string;
}

@Component({
    selector: 'app-ofertas-gallery',
    templateUrl: './ofertas-gallery.component.html',
    styleUrls: ['./ofertas-gallery.component.scss'],
})
export class GalleryComponent implements OnInit {
    @Input() imagenes: string[];
    // tslint:disable-next-line:variable-name
    @Input() id_usuario: string;

    imagenesGaleria: ImagenGaleria[] = [];
    skeletonItems = [1, 2, 3, 4, 5, 6];
    flagLoaded = false;

    constructor(
        private sanitizer: DomSanitizer,
        private dialog: MatDialog,
        private usuarioService: UsuarioService,
        private actividadesService: ActividadesService
    ) {}

    async ngOnInit(): Promise<void> {
        const lista = this.imagenes ?? [];
        const nombres = await this.resolverNombres(lista);

        this.imagenesGaleria = lista.map((imagen) => {
            const url = `${URL_BACKEND}/media/imgUserOffer/${this.id_usuario}/${imagen}`;
            return {
                url,
                safeUrl: this.sanitizer.bypassSecurityTrustUrl(url),
                nombre: nombres[imagen] || 'Documento',
            };
        });

        this.flagLoaded = true;
    }

    verImagen(item: ImagenGaleria): void {
        const imagenes = this.imagenesGaleria.map((i) => ({
            url: i.url,
            titulo: i.nombre,
        }));
        const index = this.imagenesGaleria.findIndex((i) => i.url === item.url);
        this.dialog.open(OfertasImageViewerComponent, {
            data: { imagenes, index: index < 0 ? 0 : index },
            width: 'min(1100px, 94vw)',
            maxWidth: '94vw',
            maxHeight: '98vh',
            panelClass: 'ds-dialog',
        });
    }

    trackByImagen(index: number, item: ImagenGaleria): string {
        return item.url;
    }

    /**
     * Resuelve el nombre legible de cada adjunto.
     * Prioridad: nombre del trámite -> nombre del usuario -> "Documento".
     */
    private async resolverNombres(adjuntos: string[]): Promise<{ [key: string]: string }> {
        const nombres: { [key: string]: string } = {};

        for (const adjunto of adjuntos) {
            let nombreActividad: string | null = null;
            let nombreUsuario: string | null = null;

            try {
                nombreActividad = await this.actividadesService.getNombreAdjunto(adjunto);
            } catch (error) {
                console.error(`Error obteniendo nombre de actividad para ${adjunto}:`, error);
            }

            try {
                nombreUsuario = await this.usuarioService.getNombreAdjunto(adjunto);
            } catch (error) {
                console.error(`Error obteniendo nombre de usuario para ${adjunto}:`, error);
            }

            nombres[adjunto] = nombreActividad || nombreUsuario || 'Documento';
        }

        return nombres;
    }
}
